const { transform, isArray, camelCase, isObject, isDate, startCase } = require('lodash');

/**
 * @param {string} obj
 * @returns {string}
 */
export const toTitleCase = obj => {
  return startCase(camelCase(obj));
};

/**
 * @overload
 * @param {object[]} obj
 * @returns {Record<string, unknown>[]}
 */
/**
 * @overload
 * @param {object} obj
 * @returns {Record<string, unknown>}
 */
/**
 * @param {object} obj
 * @returns {object}
 */
export const toCamelCase = obj =>
  transform(obj, (acc, value, key, target) => {
    const camelKey = isArray(target) ? key : camelCase(key);

    acc[camelKey] = isObject(value) && !isDate(value) ? toCamelCase(value) : value;
  });
